import useNetwork from 'common/hooks/useNetwork';
import React from 'react';

export default function NetworkStatus() {
  const isSlowNetwork = useNetwork();

  return (
    <div>
      {isSlowNetwork && (
        <div
          className="mb-4 flex items-center rounded-lg bg-yellow-50 p-4 text-sm text-yellow-800 dark:bg-gray-800 dark:text-yellow-300"
          role="alert"
        >
          <svg
            className="mr-3 inline h-4 w-4 shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
          </svg>
          <span className="sr-only">Info</span>
          <div>
            <span className="font-medium">Warning alert!</span> Slow network
            detected. Consider using strong connection.
          </div>
        </div>
      )}
    </div>
  );
}
